function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from 'react';
import { ResizableTitle } from '../../ResizableTitle';
export function useTableResizable(_ref) {
  var resizable = _ref.resizable,
    columns = _ref.columns;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    _columns = _useState2[0],
    setColumns = _useState2[1];
  if (!(resizable || (columns || []).some(function (col) {
    return col.resizable;
  }))) {
    return {
      columns: (columns || []).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          fieldProps: function fieldProps(form, config) {
            return _objectSpread({
              form: form
            }, typeof (col === null || col === void 0 ? void 0 : col.fieldProps) == 'function' ? col.fieldProps(form, config) : col === null || col === void 0 ? void 0 : col.fieldProps);
          }
        });
      })
    };
  }
  var handleResize = function handleResize(index) {
    return function (e, _ref2) {
      var size = _ref2.size;
      setColumns(function (columns) {
        var nextColumns = _toConsumableArray(columns);
        nextColumns[index] = _objectSpread(_objectSpread({}, nextColumns[index]), {}, {
          width: size.width
        });
        return nextColumns;
      });
    };
  };
  var columnsResize = _columns.map(function (col, index) {
    return _objectSpread(_objectSpread({}, col), {}, {
      onHeaderCell: col.resizable || typeof col.resizable === 'undefined' && resizable ? function (column) {
        return {
          width: column.width,
          onResize: handleResize(index)
        };
      } : undefined,
      fieldProps: function fieldProps(form, config) {
        return _objectSpread({
          form: form
        }, typeof (col === null || col === void 0 ? void 0 : col.fieldProps) == 'function' ? col.fieldProps(form, config) : col === null || col === void 0 ? void 0 : col.fieldProps);
      }
    });
  });
  var components = {
    header: {
      cell: ResizableTitle
    }
  };
  useEffect(function () {
    setColumns(columns);
  }, [JSON.stringify(columns)]);
  return {
    columns: columnsResize,
    components: components
  };
}